import { twMerge } from "tailwind-merge";

import { Region } from "../../../api/types/regions";
import { ApiValidationErrors } from "../../../types/api-error";
import { PriceItem } from "../../../types/price-item";
import { NoResult } from "../../dashboard-view/components/NoResult";
import { PriceUpdatePayload } from "../api/useUpdatePrice";

import { PricesTableRow } from "./PricesTableRow";
import { PriceCell } from "./ProductsWithPrices";

export type PricesTableProps = {
  items: PriceItem[];
  editedCell: PriceCell;
  selectedRegion: Region | undefined | null;
  onWorldSave: (data: Partial<PriceUpdatePayload>) => void;
  onRegionSave: (data: Partial<PriceUpdatePayload>) => void;
  onCellEdit: (data: PriceCell) => void;
  onPriceDelete: (productId: number, regionId: number) => void;
  apiErrors: ApiValidationErrors;
};

export function PricesTable({
  items,
  selectedRegion,
  editedCell,
  onWorldSave,
  onRegionSave,
  onCellEdit,
  onPriceDelete,
  apiErrors,
}: PricesTableProps) {
  return (
    <>
      <div>
        <div>
          <div
            className={twMerge(
              "grid grid-cols-4 py-4 px-4 bg-[#637383] text-white font-semibold",
              selectedRegion && "grid-cols-6",
            )}>
            <div className="col-span-1"></div>

            {/* World */}
            <div className="col-span-1 text-right">World</div>
            <div className="col-span-1"></div>

            {/* Region */}
            {selectedRegion && (
              <>
                <div className="col-span-1 text-right">
                  {selectedRegion.Name}
                </div>
                <div className="col-span-1 text-left"></div>
              </>
            )}

            {/* Actions */}
            <div className="col-span-1"></div>
          </div>
          <div
            className={twMerge(
              "grid grid-cols-4 bg-[#A6B1B7] text-white gap-0 py-4  px-4",
              selectedRegion && "grid-cols-6",
            )}>
            <div>Name</div>

            {/* World */}
            <div className="text-right">HighPricePKg (€)</div>
            <div className="text-right">PriceLowOfHigh</div>

            {/* Region */}
            {!!selectedRegion && (
              <>
                <div className="text-right">HighPricePKg (€)</div>
                <div className="text-right">PriceLowOfHigh</div>
              </>
            )}

            {/* Actions */}
            <div className="text-center"></div>
          </div>
        </div>
        <div>
          {items.length ? (
            (items || []).map(item => (
              <PricesTableRow
                item={item}
                onCellEdit={onCellEdit}
                onRegionSave={onRegionSave}
                onWorldSave={onWorldSave}
                onPriceDelete={onPriceDelete}
                editedCell={editedCell}
                selectedRegion={selectedRegion}
                apiErrors={apiErrors}
              />
            ))
          ) : (
            <div className="w-full pt-4">
              <NoResult />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
